exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.double-ctrl-wrap>tbody>tr>td {\n\tpadding-right: 5px;\n    vertical-align: middle;\n}\n.double-ctrl-wrap {\n\t/* margin-bottom: 15px; /* как .help-block, это значение должно быть одинаковым в datetime.vue и datetime_double.vue */\n}\n", ""]);
